import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateService } from 'src/app/services/create.service';

@Component({
  selector: 'app-create-dialog',
  templateUrl: './create-dialog.component.html',
  styleUrls: ['./create-dialog.component.scss']
})
export class CreateDialogComponent {

  userEmailId = this.storage.retrieve("userEmailId");
  createFolderFileObj: any = {
    userEmail: this.userEmailId,
    destFolderId: "",
    name: '',
    fileType: ''
  };
  message: string = '';
  success: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, private dialogRef: MatDialog, private storage: LocalStorageService, private createService: CreateService) {
    console.log(data);
  }

  ngOnInit() {
    this.createFolderFileObj = {
      userEmail: this.userEmailId,
      destFolderId: this.data.folder.id,
      fileType: this.data.type,
      name: ''
    }
  }

  createInDrive() {
    if (this.createFolderFileObj.name.length != 0) {
      this.createService.createFile(this.createFolderFileObj).subscribe({
        next: (data: any) => {
          console.log(data);
          this.success = true;
          this.message = data;
        },
        error: (e: any) => {
          if(e.status == 403){
            this.toastr.error(e.error + " " + "(Insufficient Permission)");
          }else{
            this.toastr.error('The ' + this.data.type + ' could not be created. Kindly try again later.', 'Error!');
          }
        }
      });
    }
  }

  copyLink() {
    
  }
}